/**
 * Just a helper class to manage animation frame
 */
export class AnimationFramePender {
    #animationID : ReturnType<typeof requestAnimationFrame> = 0
    overwrite(fn : () => void) {
        this.cancel()
        this.#animationID = requestAnimationFrame(fn)
    }
    // set(fn : () => void) {
    //     this.#animationID = requestAnimationFrame(fn)
    // }
    cancel() {
        cancelAnimationFrame(this.#animationID)
    }
}

/**
 * Polyfill
 */
let requestIdleCallbackPolyfilled : (cb : () => void, ms? : number) => number
let cancelIdleCallbackPolyfilled : (registration : number) => void
if ('requestIdleCallback' in window) {
    requestIdleCallbackPolyfilled = (cb, ms = 0) => window.requestIdleCallback(cb)
    cancelIdleCallbackPolyfilled = (registration) => window.cancelIdleCallback(registration) 
} else {
    requestIdleCallbackPolyfilled = (cb, ms = 0) => window.setTimeout(cb, ms)
    cancelIdleCallbackPolyfilled = (registration) => window.clearTimeout(registration)
}

/**
 * Idle Callback with a built-in polyfill
 */
export class IdleCallbackPender {
    #idleCallbackID : ReturnType<typeof requestAnimationFrame> = 0
    #fn : (() => void ) | null = null

    constructor(public readonly ms = 0) {}

    overwrite(fn : () => void) {
        this.cancel()
        this.#fn = fn
        this.#idleCallbackID = requestIdleCallbackPolyfilled(() => {
            this.#fn = null
            fn()
        }, this.ms)
    }
    // set(fn : () => void) {
    //     this.#animationID = requestAnimationFrame(fn)
    // }
    /**
     * Cancels the wait and runs the queued function immediately
     */
    run() {
        if (this.#fn !== null) this.#fn
    }
    cancel() {
        cancelIdleCallbackPolyfilled(this.#idleCallbackID)
    }
}

export class TimerPender {
    #timerCallbackID : ReturnType<typeof window.setTimeout> | number = 0

    constructor(public readonly ms = 0) {}

    overwrite(fn : () => void) {
        this.cancel()
        this.#timerCallbackID = setTimeout(fn, this.ms)
    }
    // set(fn : () => void) {
    //     this.#animationID = requestAnimationFrame(fn)
    // }
    cancel() {
        clearTimeout(this.#timerCallbackID)
    }
}